import { twMerge } from 'tailwind-merge';

type CardProps = {
  title?: string | React.ReactNode;
  headerElement?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  cardClassName?: string;
  bodyClassName?: string;
  footerClassName?: string;
  onClick?: () => void;
};

const Card = ({
  title,
  headerElement,
  children,
  footer,
  cardClassName,
  bodyClassName,
  footerClassName,
  onClick,
}: CardProps) => {
  const handleClick = () => {
    if (onClick) onClick();
  };

  return (
    <div className={twMerge('card', cardClassName)} onClick={handleClick}>
      {headerElement ? (
        <div className="card-header border-b-gray-E4E4E4">{headerElement}</div>
      ) : (
        title && (
          <div className="card-header border-b-gray-E4E4E4">
            <h2 className="w-full card-title">{title}</h2>
          </div>
        )
      )}
      <div className={twMerge('card-body', bodyClassName)}>{children}</div>
      {footer && (
        <div
          className={twMerge(
            'card-footer border-t-gray-E4E4E4 justify-end',
            footerClassName
          )}
        >
          {footer}
        </div>
      )}
    </div>
  );
};

export default Card;
